import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import FriendDetails from "./friend_details";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "FriendNewsfeedUpdate",


  propTypes: {
    resource: GrPropTypes.friendNewsfeedResource(),
  },

  render() {
    const icon =  <UserIcon user={this.props.resource.friendUser} size={ICON_SIZES.LARGE}/>;
    const body = <SocialUpdateBody customIcon={icon}>
                 <FriendDetails {...this.props.resource}/>
               </SocialUpdateBody>;

    return <SocialUpdate
      header={<span>is now friends with:</span>}
      body={body}
      {...this.props}
      />;
  },
});
